import React from 'react';

import { IBudgetItem } from 'modules/checkout/domain/entities';
import { SectionAccordion } from 'modules/checkout/presentation/components/atoms';
import { BudgetItem } from 'modules/checkout/presentation/components/molecules';
import { PackageImage } from 'shared/presentation/components/atoms';
import { useLocale } from 'shared/presentation/contexts';
import { useMediaQuery } from 'shared/presentation/hooks';

import * as S from './styles';

interface IPackagesAccordionProps {
  items: IBudgetItem[];
  defaultOpen?: boolean;
  emphasizeSessions?: boolean;
}

const ACTION_IMAGES_SIZE = 40;

const PackagesAccordion: React.FC<IPackagesAccordionProps> = ({
  items,
  defaultOpen,
  emphasizeSessions,
}) => {
  const { t } = useLocale('checkout');
  const isMobile = useMediaQuery('md');

  return (
    <SectionAccordion
      title={t('Order items', {
        count: items.length,
      })}
      indicatorType={isMobile ? 'icon' : 'text'}
      defaultOpen={defaultOpen}
      actions={
        !isMobile &&
        items
          .slice(0, 4)
          .map(item => (
            <PackageImage
              key={item.id}
              src={item.image}
              alt={item.title}
              size={ACTION_IMAGES_SIZE}
            />
          ))
      }
    >
      <S.Container>
        {items.map(item => (
          <BudgetItem
            key={item.id}
            item={item}
            emphasizeSessions={emphasizeSessions}
          />
        ))}
      </S.Container>
    </SectionAccordion>
  );
};

export default PackagesAccordion;
